/**
 * Carrega o script do componente da página inicial.
 */
export  function loadComponentScript(): void {
  // Itera por todos os elementos no documento.
  document.querySelectorAll("*").forEach(({ tagName }) => {
    // Converte o nome da tag para letras minúsculas.
    const lowerTagName = tagName.toLowerCase();
    
    // Verifica se a tag começa com "wc-" e contém pelo menos um hífen.
    if (lowerTagName.startsWith("wc-") && lowerTagName.includes("-")) {
      // Importa o script do componente da página inicial.
      const [prefix, ...rest] = lowerTagName.split("-");
      
      import(`../ui/components/${rest[0]}/${prefix}-${rest[rest.length-1]}.ts`);

    }
  });
}
